import { Component } from '@angular/core';
import { SwiperInitService } from 'src/app/shared/swiper-init.service';

declare var $: any;

@Component({
  selector: 'app-our-features',
  templateUrl: './our-features.component.html',
  styleUrl: './our-features.component.scss'
})
export class OurFeaturesComponent {
  constructor(private swiperInitService: SwiperInitService) { }
  ngAfterViewInit(): void {
    this.swiperInitService.initSliders();
  }
  ngOnInit(): void {
    
  }
}
